/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import classes from './BottomMenu.module.css';
import { Box, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import Hold from "../Icons/Hold";
import { makeStyles } from '@mui/styles';
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useResolvedPath,
  useSearchParams,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import action from '../../Redux Store/actions';
import MenuIcon from '@mui/icons-material/Menu';
import Event from '../Icons/Event';
import Project from '../Icons/Project';
import Sustenance from '../Icons/Sustenance';
import AllAllotments from '../Icons/AllAllotments';
import BenefitPlan from '../Icons/BenefitPlan';
import ChannelPartner from '../Icons/ChannelPartner';
import FastBooking from '../Icons/FastBooking';
import Leads from '../Icons/Leads';
import Payments from '../Icons/Payments';
import Settings from '../Icons/Settings';
import Token from '../Icons/Token';
import User from '../Icons/User';
import BackArrow from '../Icons/BackArrow';
import ArrowDropDownIcon from '../Icons/ArrowDropDownIcon';
import ArrowRightIcon from '../Icons/ArrowRightIcon';
import RocketIcon from '../Icons/RocketIcon';
import CPSelected from '../Icons/CPSelected';
import ProfileIcon from '../../Assets/Images/Common/ProfileIcon.svg';
import CallIcon from '../Icons/CallIcon';
import CallHistoryIcon from '../Icons/CallLogs';

const useStyles = makeStyles((theme) => ({
  menu_item: {
    marginBottom: '0.5rem !important',
    justifyContent: 'space-evenly !important',
    '&:hover': {
      background: '#EFF8FF',
      borderRadius: '0px 20px 20px 0px !important',
    },
    // border:"none! important",
    // background:"#FFFFF !important"
  },
  icon: {
    // minWidth: "1.8rem !important",
    // marginRight: "1.7rem",
    // marginLeft: "1.3rem",
    minWidth: '2.8rem !important',
    marginRight: '1.3rem',
    marginLeft: '1.7rem',
  },
  menu: {
    margin: '0',
    '& span': {
      display: 'inline-block',
      fontFamily: 'Roboto-Regular',
      fontSize: '1.4rem',
      lineHeight: '2rem',
      color: '#667085',
      fontWeight: '400',
      marginLeft: '1rem',
    },
  },
  active: {
    background: '#EFF8FF !important',
    borderRadius: '0px 20px 20px 0px !important',
    color: '#FFFFFF',
    '& span': {
      color: '#1570EF',
      // background: "#1570EF"
    },
    '&:hover': {
      background: '#1570EF',
    },
  },
  subMenutitle: {
    fontFamily: 'Roboto-Regular',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: '#667085',
  },
  user_avatar: {
    display: 'inline-block !important',
    marginRight: '1.2rem !important',
    verticalAlign: 'middle !important',
    width: '4rem !important',
    height: '4rem !important',
    '& svg': {
      transform: 'translate(-50%, -50%)',
      top: '50%',
      left: '50%',
      position: 'relative',
    },
  },
}));

export default function BottomMenu({ props }) {
  const classList = useStyles();
  const navigate = useNavigate();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);

  const [index, setIndex] = useState(0);
  const [menuArray, setMenuArray] = useState([
    {
      icon: <BenefitPlan color={'#667085'} fill={'none'} />,
      activeIcon: <BenefitPlan color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Dashboard',
      tabName: 'Dashboard',
      isVisible: true,
      path: '/home/Dashboard',
    },
    {
      // Matches the entry SideMenu.jsx already has for the desktop sidebar —
      // same icon choice, same "Sales Dashboard" permission key.
      icon: <BenefitPlan color={'#667085'} fill={'none'} />,
      activeIcon: <BenefitPlan color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Sales Dashboard',
      tabName: 'salesdashboard',
      isVisible: true,
      path: '/home/SalesDashboard',
    },
    {
      icon: <Event color={'#667085'} fill={'none'} />,
      activeIcon: <Event color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Event',
      tabName: 'Event',
      isVisible: true,
      path: '/home/Event',
    },
    {
      icon: <Project color={'#667085'} fill={'none'} />,
      activeIcon: <Project color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Project',
      tabName: 'Project',
      isVisible: true,
      path: '/home/Projects',
    },
    {
      icon: <Hold color={'#667085'} fill={'none'} />,
      activeIcon: <Hold color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Hold/Release',
      tabName: 'Hold/Release',
      isVisible: true,
      path: '/home/Hold',
    },
    {
      icon: <CallIcon color={'#667085'} fill={'none'} />,
      activeIcon: <CallIcon color={'#FFFF'} fill={'#1570EF'} />,
      name: 'SmartFlo',
      tabName: 'smartflo',
      isVisible: true,
      path: '/home/SmartFlo',
    },
    {
      icon: <Sustenance color={'#667085'} fill={'none'} />,
      activeIcon: <Sustenance color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Sustenance',
      tabName: 'sustenance',
      isVisible: true,
      path: '/home/Sustenance',
    },
    {
      icon: <Token color={'#667085'} fill={'none'} />,
      activeIcon: <Token color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Token',
      tabName: 'Token',
      isVisible: true,
      path: '/home/Token',
    },
    {
      icon: <ChannelPartner color={'#667085'} fill={'none'} />,
      activeIcon: <CPSelected />,
      name: 'Channel Partner',
      tabName: 'channelpartner',
      isVisible: true,
      path: '/home/ChannelPartner',
    },
    {
      icon: <Payments color={'#667085'} fill={'none'} />,
      activeIcon: <Payments color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Payments',
      tabName: 'payments',
      isVisible: true,
      path: '/home/Payments',
    },
    {
      icon: <Leads color={'#667085'} fill={'none'} />,
      activeIcon: <Leads color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Leads',
      tabName: 'Leads',
      isVisible: true,
      path: '/home/Leads',
    },
    {
      icon: <FastBooking color={'#667085'} fill={'none'} />,
      activeIcon: <FastBooking color={'#1570EF'} fill={'#1570EF'} />,
      name: 'FastBooking',
      tabName: 'fastbooking',
      isVisible: true,
      path: '/home/FastBooking',
    },
    {
      icon: <BenefitPlan color={'#667085'} fill={'none'} />,
      activeIcon: <BenefitPlan color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Benefit Plan',
      tabName: 'benefitplan',
      isVisible: true,
      path: '/home/BenefitPlan',
    },
    {
      icon: <AllAllotments color={'#667085'} />,
      activeIcon: <AllAllotments color={'#1570EF'} />,
      name: 'All Allotments',
      tabName: 'AllAllotments',
      isVisible: true,
      path: '/home/AllAllotments',
    },
    {
      icon: <CallHistoryIcon color={"#667085"} fill={"none"} />,
      activeIcon: <CallHistoryIcon color={"#FFFF"} fill={"#1570EF"} />,
      name: "CallLogs",
      tabName: "CallLogs",
      isVisible: true,
      path: "/home/callLogs",
    },
     {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "Sales Manager Persona",
      tabName: "SalesManagerPersona",
      isVisible: true,
      path: "/home/salesManagerPersona",
    },
    {
      icon: <User color={'#667085'} fill={'none'} />,
      activeIcon: <User color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Users',
      tabName: 'users',
      isVisible: true,
      path: '/home/users',
    },
    {
      icon: <Settings color={'#667085'} />,
      activeIcon: <Settings color={'#1570EF'} />,
      name: 'Settings',
      tabName: 'Settings',
      isVisible: true,
      path: '/home/Settings',
    },
    {
      icon: <Leads color={'#667085'} fill={'none'} />,
      activeIcon: <Leads color={'#FFFF'} fill={'#1570EF'} />,
      name: 'Queue',
      tabName: 'Queue',
      isVisible: true,
      path: '/home/Queue',
    },
    {
      icon: <FastBooking color={'#667085'} fill={'none'} />,
      activeIcon: <FastBooking color={'#1570EF'} fill={'#1570EF'} />,
      name: 'Live Inventory',
      tabName: 'liveInventory',
      isVisible: true,
      path: '/home/LiveInventory',
    },
  ]);
  const activeMenu = useSelector((state) => state.ActiveMenu.activeMenu);

  return (
    <Box
      sx={{
        borderRadius: '1.3rem 1.3rem 0 0',
        bgcolor: '#fff',
        boxShadow: '0px 0px 15px rgb(73 83 211 / 10%)',
        height: '10%',
        width: '100%',
        maxWidth: '100vw',
        minWidth: 0,
        overflow: 'hidden',
        // display: keyboardOpen ? 'none' : ''
      }}
    >
      <Tabs
        sx={{
          width: '100%',
          height: '100%',
          minWidth: 0,
          justifyContent: 'center',
        }}
        size='sm'
        aria-label='Bottom Navigation'
        value={index}
        onChange={(event, value) => setIndex(value)}
      >
        {/* This row has 8 tabs — more than a phone width fits at a legible
            size. Without its own scroll container the row's natural width
            forced the whole page wider (a page-wide horizontal scrollbar),
            instead of just this bar scrolling. minWidth:0 lets it actually
            shrink to the viewport so overflowX:auto can take over; the
            scrollbar is hidden for a native bottom-nav feel (still swipeable). */}
        <TabList
          variant='plain'
          sx={{
            padding: '0',
            minWidth: 0,
            overflowX: 'auto',
            overflowY: 'hidden',
            flexWrap: 'nowrap',
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          {menuArray
            ?.filter(
              (f) =>
                loggedInUser?.roleId?.accessibleTabs?.[f?.name]?.isAccessible
            )
            .map(
              (menu, index) =>
                (menu.name === 'Event' ||
                  menu.name === 'Project' ||
                  menu.name === 'Leads' ||
                  menu.name === 'CallLogs' ||
                  menu.name === 'Dashboard' ||
                  menu.name === 'Hold/Release' ||
                  menu.name === 'SmartFlo' ||
                  menu.name === 'Sales Dashboard')
                && (
                  <Tab
                    orientation='vertical'
                    sx={{
                      color:
                        activeMenu === menu.tabName.toLowerCase()
                          ? '#28303F'
                          : '#98A2B3',
                      '&:hover': {
                        color: '#98A2B3',
                      },
                      gap: '1rem',
                      flexShrink: 0,
                      whiteSpace: 'nowrap',
                    }}
                    className={classes.mobile_menu}
                    onClick={(e) => {
                      navigate(menu.path);
                    }}
                  >
                    <div
                      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                      onClick={() => { navigate(menu.path); }}
                    >
                      <ListItemIcon className={classList.icon}>
                        {activeMenu === menu.tabName.toLowerCase()
                          ? menu.activeIcon
                          : menu.icon}
                      </ListItemIcon>
                      {menu.name}
                    </div>
                  </Tab>
                )
            )}
          <Tab
            orientation='vertical'
            sx={{
              color: activeMenu === 'mobileSubMenu' ? '#28303F' : '#98A2B3',
              '&:hover': {
                color: '#98A2B3',
              },
              gap: '0.5rem',
              flexShrink: 0,
              whiteSpace: 'nowrap',
            }}
            className={classes.mobile_menu}
            onClick={(e) => {
              navigate('/home/MobileSubMenu');
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
              onClick={() => { navigate('/home/MobileSubMenu'); }}
            >
              <ListItemIcon className={classList.icon}>
                {activeMenu === 'mobileSubMenu' ? (
                  <Settings color={'#1570EF'} />
                ) : (
                  <Settings color={'#667085'} />
                )}
              </ListItemIcon>
              Settings
            </div>
          </Tab>
        </TabList>
      </Tabs>
    </Box>
  );
}
